import { STOCK_STATUS_PRIORITY } from "@features/product/config/const";

export function isIncomingStock(stock: number) {
  return stock === STOCK_STATUS_PRIORITY.Incoming;
}
